import { SVGInterface } from "../../interface";

const Floors = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM18 6H13.58V9.33H11V12.66H8.42V16H6V18H10.42V14.67H13V11.34H15.58V8H18V6Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Floors;
